var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-container"},[_c('div',{staticClass:"details-header"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.title))])])],2),_c('div',{staticClass:"details"},[_vm._t("body"),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }